import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ListItem } from '../models/lists.model';
import { GenericListService } from './lists.service';

export enum AROrgeListType {
  ORGE_RESULT_TYPES,
}

// TODO refactor lists.service pour ne pas dupliquer le code commun avec ARColza ?
@Injectable({ providedIn: 'root' })
export class AROrgeListsService extends GenericListService<AROrgeListType> {
  constructor(http: HttpClient) {
    super(http);
    this.listsUrl = '/tools/agrorendement/orge/lists';
  }

  handleResponse(response: any) {
    const data = response.data;
    const converted = new Map<AROrgeListType, ListItem[]>();
    for (const d in data) {
      const listType: AROrgeListType = <any>AROrgeListType[<any>d];
      const value = data[d];
      const typeData = value.map(this.extractI18n);
      converted.set(listType, typeData);
      this.cache.set(listType, typeData);
    }
    return converted;
  }
}
